import React from 'react';
import './analyticsAsk.css';

// Pure module — NO context/service imports (statically testable in this no-jsdom workspace).

/** Graceful-degrade card for `{kind:'unsupported'}`. The server message is a fixed,
 *  already-safe template (backend/src/routes/analytics.js UNSUPPORTED_MESSAGE) — this
 *  component never invents or forwards an internal reason/enum name. `nearest` (if any) is
 *  rendered with explicit substitution copy so it is never mistaken for the actual answer to
 *  what was asked. */
export default function UnsupportedCard({ message, nearest, onRunNearest, onPickSuggestion, suggestions = [] }) {
  return (
    <div className="aa-unsupported">
      <strong className="aa-unsupported__heading">Not yet — I’ve noted it</strong>
      <p className="aa-unsupported__message">{message}</p>
      {nearest && (
        <div className="aa-nearest">
          <div className="aa-nearest__label">Closest I can answer now:</div>
          <button type="button" className="aa-chip aa-chip--nearest" onClick={() => onRunNearest?.(nearest)}>
            {nearest.label}
          </button>
        </div>
      )}
      {suggestions.length > 0 && (
        <div className="aa-unsupported__suggestions">
          {suggestions.map((s) => (
            <button key={s.metric} type="button" className="aa-chip" onClick={() => onPickSuggestion?.(s)}>
              {s.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
